import React from "react";

import DomainDisabledIcon from "@mui/icons-material/DomainDisabled";
import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { IAccountGroup } from "../../../../api/fundedCompliance/index.types";
import EditGroupAccount from "../EditTraderAccounts";
import AddAccountInGroup from "../AddAccountInGroup";
import { getEntriesIdWithPrefix } from "../EntriesIdWithPrefix";

const accountNameStyle = { display: "flex", height: "26px", alignItems: "end" };
const outerAccountNameStyle = {
  display: "flex",
  height: "22px",
  justifyContent: "flex-start",
  alignItems: "center",
  borderRadius: "5px",
  backgroundColor: "rgb(254, 197, 187)",
  padding: "0",
};
const domainDisabledIconStyle = { fontSize: "18px", marginLeft: "5px" };

export const TRADERS_DB_LIST_COLUMNS: Array<IColum> = [
  {
    isSortable: true,
    by: "id",
    title: "Entries ID",
    path: "id",
    //@ts-ignore
    getCellValue: (complianceTraderId: number): React.ReactElement => {
      return <AddAccountInGroup complianceTraderId={complianceTraderId} isDisableEdit={true} />;
    },
    //@ts-ignore
    copyToClipBoardCallBack: (value: number): string => getEntriesIdWithPrefix(value),
  },
  {
    by: "name",
    title: "Name",
    path: "compliance_traders_accounts",
    //@ts-ignore
    copyToClipBoardCallBack: (value: IAccountGroup["compliance_traders_accounts"]): string => {
      return value
        .map(
          ({ account, submissions_outer_account }) =>
            account?.name || submissions_outer_account.name
        )
        .join(", ");
    },
    //@ts-ignore
    getCellValue: (value: IAccountGroup["compliance_traders_accounts"]): React.ReactElement => {
      return (
        <>
          {value.map(({ account, submissions_outer_account }, index) => {
            const key = (account?.id || submissions_outer_account.id) + `_${index}`;
            return account ? (
              <div style={accountNameStyle} key={key}>
                {account.name}
              </div>
            ) : (
              <div style={outerAccountNameStyle} key={key}>
                {submissions_outer_account.name}
                <DomainDisabledIcon style={domainDisabledIconStyle} />
              </div>
            );
          })}
        </>
      );
    },
  },
  {
    by: "email",
    title: "Email",
    path: "compliance_traders_accounts",
    //@ts-ignore
    copyToClipBoardCallBack: (value: IAccountGroup["compliance_traders_accounts"]): string => {
      return value
        .map(
          ({ account, submissions_outer_account }) =>
            account?.email || submissions_outer_account.email
        )
        .join(", ");
    },
    //@ts-ignore
    getCellValue: (value: IAccountGroup["compliance_traders_accounts"]): React.ReactElement => {
      return (
        <>
          {value.map((account, index) => {
            if (account.account) {
              return <EditGroupAccount key={`${account.account.id}${index}`} account={account} />;
            }
            return (
              <EditGroupAccount
                key={`${account.submissions_outer_account.email}${index}`}
                account={account}
              />
            );
          })}
        </>
      );
    },
  },
];

export const FUNDED_COMPLIANCE_FILTERS = {
  "Entries ID": "compliance_entries_id",
  Name: "name",
  Email: "email",
};
